/**
 * Replaces (or adds) a `key:value` term in an omnisearch DSL string, quoting
 * values that contain whitespace. Used by the vendor-dashboard tiles to drive
 * the manifests grid filter from chart clicks. tenantId / shippedDate are NOT
 * injected here — they come from the grid's defaultSearch (smart-merged).
 *
 * `key` is escaped before being interpolated into the strip regex so a future
 * caller passing a dotted form like `facility.name` doesn't turn `.` into a
 * wildcard. Inner `"` and `\` in `value` are backslash-escaped on the way out
 * and reversed by the strip regex so a vendor labelled `Foo "Inc"` round-trips
 * cleanly instead of corrupting the search on the next click.
 */
export function upsertOmnisearchTerm(search: string, key: string, value: string): string {
  const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  // Quoted segment matches a `"`-delimited value with backslash escapes, so the
  // strip pairs with the escape we apply to the value below.
  const stripRegex = new RegExp(`(?:^|\\s)${escapedKey}:(?:"(?:\\\\.|[^"\\\\])*"|\\S+)`, "gi");
  const cleaned = search.replace(stripRegex, " ").replace(/\s+/g, " ").trim();
  const needsQuotes = /[\s"\\]/.test(value);
  const serialized = needsQuotes ? `"${value.replace(/(["\\])/g, "\\$1")}"` : value;
  return `${cleaned} ${key}:${serialized}`.trim();
}
